import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ChevronRight, Shield, Leaf } from 'lucide-react';
import { FAQAccordion } from '../../components/FAQAccordion';
import { CTAStrip } from '../../components/CTAStrip';
import { InlineCostCalculator } from '../../components/InlineCostCalculator';
const faqs = [{
  question: 'What types of commercial waste do you collect?',
  answer: "We collect general commercial waste, builders' waste, shopfitter waste, confidential waste, WEEE (electrical), and more. Contact us if you're unsure."
}, {
  question: 'Do you provide waste transfer notes?',
  answer: 'Yes, always. All commercial waste collections come with full duty of care documentation as required by law.'
}, {
  question: 'Can you set up a regular collection schedule?',
  answer: 'Absolutely. We offer weekly, fortnightly, and monthly scheduled collections with contract pricing.'
}, {
  question: 'Are you licensed to carry commercial waste?',
  answer: 'Yes. We are fully registered with the Environment Agency as an upper-tier waste carrier.'
}, {
  question: 'Do you offer skip alternatives?',
  answer: 'Yes. Our wait-and-load service is often faster and cheaper than a skip, with no permit required.'
}];
export function CommercialWastePage() {
  return <div className="pt-16 lg:pt-20" data-id="element-759">
      <section className="relative h-72 md:h-96 overflow-hidden" data-id="element-760">
        <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1600&auto=format&fit=crop" alt="Commercial waste" className="w-full h-full object-cover" data-id="element-761" />
        <div className="absolute inset-0 hero-overlay" data-id="element-762" />
        <div className="absolute inset-0 flex items-center" data-id="element-763">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-764">
            <nav className="flex items-center gap-2 text-green-200 text-sm mb-4" data-id="element-765">
              <Link to="/" className="hover:text-white" data-id="element-766">
                Home
              </Link>
              <ChevronRight className="w-4 h-4" data-id="element-767" />
              <Link to="/services" className="hover:text-white" data-id="element-768">
                Services
              </Link>
              <ChevronRight className="w-4 h-4" data-id="element-769" />
              <span className="text-white" data-id="element-770">Commercial Waste</span>
            </nav>
            <h1 className="text-3xl md:text-5xl font-extrabold text-white" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-771">
              Commercial Waste Collection London
            </h1>
            <p className="text-green-100 mt-3 text-lg" data-id="element-772">
              Licensed, documented, eco-responsible. From £80/collection.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white" data-id="element-773">
        <div className="max-w-7xl mx-auto" data-id="element-774">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-775">
            <div data-id="element-776">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-777">
                What's Included
              </h2>
              <ul className="space-y-3" data-id="element-778">
                {['General commercial waste collection', "Builder's & construction waste", 'Shopfitter & retail waste', 'Confidential waste disposal', 'WEEE & electrical equipment', 'Scheduled or one-off collections', 'Waste transfer notes provided', 'Eco-reporting available'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-779">
                    <CheckCircle className="w-5 h-5 flex-shrink-0" style={{
                  color: '#1B8F4B'
                }} data-id="element-780" />
                    <span className="text-gray-700" data-id="element-781">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-782">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-783">
                Ideal For
              </h2>
              <div className="space-y-4" data-id="element-784">
                {[{
                title: 'Construction Sites',
                desc: "Regular or one-off builder's waste removal."
              }, {
                title: 'Retail & Hospitality',
                desc: 'Shopfitter waste and regular commercial collections.'
              }, {
                title: 'Property Developers',
                desc: 'Site clearance and ongoing waste management.'
              }, {
                title: 'Offices & Businesses',
                desc: 'General commercial waste and recycling.'
              }].map(({
                title,
                desc
              }) => <div key={title} className="p-4 rounded-xl border border-gray-100 hover:border-[#1B8F4B] transition-colors" data-id="element-785">
                    <h3 className="font-bold text-gray-900 mb-1 text-sm" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-786">
                      {title}
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-787">{desc}</p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white" data-id="element-788">
        <div className="max-w-3xl mx-auto text-center" data-id="element-789">
          <div className="rounded-2xl border-2 border-[#1B8F4B] p-8 mb-6" data-id="element-790">
            <p className="text-4xl font-extrabold mb-2" style={{
            color: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-791">
              From £80
            </p>
            <p className="text-gray-500 mb-6" data-id="element-792">
              Per collection. Contract pricing available for regular customers.
            </p>
            <Link to="/contact" className="inline-block px-8 py-4 rounded-xl font-bold text-white transition-colors hover:opacity-90" style={{
            backgroundColor: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-793">
              Request a Quote
            </Link>
          </div>
          <div className="flex justify-center gap-6" data-id="element-794">
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-795">
              <Shield className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-796" />{' '}
              Licensed & Fully Insured
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-797">
              <Leaf className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-798" />{' '}
              Eco-Friendly Disposal
            </div>
          </div>
        </div>
      </section>

      <InlineCostCalculator defaultService="commercial-waste" serviceName="Commercial Waste" data-id="element-799" />

      <section className="py-16 px-4 bg-white" data-id="element-800">
        <div className="max-w-3xl mx-auto" data-id="element-801">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-802">
            FAQs
          </h2>
          <FAQAccordion items={faqs} data-id="element-803" />
        </div>
      </section>
      <CTAStrip data-id="element-804" />
    </div>;
}